export default __webpack_public_path__ + "static/media/warning--tractors--g3.bc827995.png";